import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { useRef, useEffect, useState } from "react";
import EChartsReact from "echarts-for-react";
import * as echarts from "echarts";
import "echarts-gl";
import china from "@/assets/map/china-province.json";
import neimenggu from "@/assets/map/150000_full.json";
import sh from "@/assets/data/sh.json";
import Icon from "@/assets/img/eam/chart_icon.png";
import { Descriptions } from "antd";
import { eamApi } from "@/api/eamApi";
// 可下钻省份配置：省份名称 -> 对应子地图标识
const drillMapConfig = {
    上海市: "shanghai",
    内蒙古自治区: "neimenggu",
};
// ===================== Mock 统一数据源（全国+上海区县+新疆区县） =====================
const mockAllRegionData = [
    // 全国省份数据
    {
        cname: "上海市",
        mapType: "china",
        count: 1256,
        value: 386000000,
        netValue: 242000000,
        inboundAssetNum: 45,
        outboundAssetNum: 45,
        scrapAssetNum: 1,
    },
    {
        cname: "内蒙古自治区",
        mapType: "china",
        count: 3842,
        value: 1572000000,
        netValue: 985000000,
        inboundAssetNum: 128,
        outboundAssetNum: 20,
        scrapAssetNum: 1,
    },
    // 上海区县数据
    {
        cname: "闵行区",
        mapType: "shanghai",
        count: 426,
        value: 128600000,
        netValue: 76500000,
        inboundAssetNum: 12,
        outboundAssetNum: 8,
        scrapAssetNum: 0,
    },
    {
        cname: "浦东新区",
        mapType: "shanghai",
        count: 689,
        value: 215000000,
        netValue: 132000000,
        inboundAssetNum: 22,
        outboundAssetNum: 15,
        scrapAssetNum: 1,
    },
    // 内蒙古区县数据（原注释写错新疆，同步修正文案）
    {
        cname: "包头市",
        mapType: "neimenggu",
        count: 1560,
        value: 620000000,
        netValue: 390000000,
        inboundAssetNum: 56,
        outboundAssetNum: 9,
        scrapAssetNum: 0,
    },
    {
        cname: "赤峰市",
        mapType: "neimenggu",
        count: 986,
        value: 410000000,
        netValue: 268000000,
        inboundAssetNum: 32,
        outboundAssetNum: 5,
        scrapAssetNum: 1,
    },
];
// ===================== 通用工具函数 =====================
/** 根据当前地图类型过滤对应区域名称数组 */
const getRegionListByMap = (list, mapType) => {
    return list
        .filter((item) => item.mapType === mapType)
        .map((item) => item.cname);
};
/**
 * 获取3D地图视角控制 viewControl 配置（控制地图左右偏移、远近、旋转）
 * 字段说明：
 * distance：相机距离，数值越小地图视觉越大，越大越小
 * target：[经度,纬度,高度] 视角中心点，**经度减小=整体地图向左偏移**
 * autoRotate：是否自动旋转
 * autoRotateSpeed：旋转速度
 * autoRotateAfterStill：鼠标静止几秒后恢复自动旋转
 * alpha：相机俯仰角度，控制地图高低视角
 * minDistance/maxDistance：滚轮缩放最小/最大距离限制
 */
const getViewControl = (mapType) => {
    // 全国地图放大视距 + 左移视角，避开右侧详情面板遮挡
    if (mapType === "china") {
        return {
            distance: 75,
            autoRotate: true,
            target: [75, 30, 0], // 原36 → 30，整体大幅向下移动
            autoRotateSpeed: 3,
            autoRotateAfterStill: 3,
            alpha: 50, // 原50，降低俯视角度，画面整体下沉
            minDistance: 60,
            maxDistance: 75,
        };
    }
    // 上海、内蒙古子地图保持居中不偏移
    return {
        distance: 80,
        autoRotate: true,
        target: [121.47, 31.23, 0],
        autoRotateSpeed: 3,
        autoRotateAfterStill: 3,
        alpha: 50,
        minDistance: 70,
        maxDistance: 80,
    };
};
/** 获取地图样式配置 + 3D盒子尺寸（关键修复：全国box放大） */
const getMapStyle = (mapType) => {
    if (mapType === "china") {
        return {
            borderColor: "#075580",
            borderWidth: 0.5,
            zoom: 1, // 全国图层放大
            boxWidth: 100, // 3D容器加宽加高
            boxHeight: 100,
            regionHeight: 6,
        };
    }
    // 区县子地图保持缩小适配
    return {
        borderColor: "#ffffff",
        borderWidth: 2,
        zoom: 1,
        boxWidth: 70,
        boxHeight: 70,
        regionHeight: 8,
    };
};
const AssetMapAndtL7 = ({ className = "", url, onClick, }) => {
    const chartRef = useRef(null);
    const containerRef = useRef(null);
    const dataSourceRef = useRef([]);
    // 地图注册标记，支持全国/上海/内蒙古
    const mapRegisteredRef = useRef({
        china: false,
        shanghai: false,
        neimenggu: false,
    });
    // 当前展示地图
    const [currentMapType, setCurrentMapType] = useState("china");
    const [mapReady, setMapReady] = useState(false);
    const [activeRegion, setActiveRegion] = useState("上海市");
    const [isClicking, setIsClicking] = useState(false);
    const [mapError, setMapError] = useState(null);
    const [isRotating, setIsRotating] = useState(true);
    const [dataSource, setDataSource] = useState([]);
    // 当前地图下所有高亮区域
    const targetRegions = getRegionListByMap(dataSource, currentMapType);
    const regionIndexRef = useRef(0);
    const pollTimerRef = useRef(null);
    // 区域名称映射详情
    const regionDetails = dataSource.reduce((acc, item) => {
        acc[item.cname] = item;
        return acc;
    }, {});
    useEffect(() => {
        dataSourceRef.current = dataSource;
    }, [dataSource]);
    // 初始化mock数据，线上切换为接口getData()
    useEffect(() => {
        setDataSource(mockAllRegionData);
        // getData();
    }, []);
    // 接口请求
    const getData = async () => {
        try {
            const res = await eamApi.area(url);
            setDataSource(res.data);
        }
        catch (error) {
            console.error("获取区域资产数据失败:", error);
        }
    };
    // 统一注册所有地图
    useEffect(() => {
        const registerAllMap = async () => {
            try {
                // 注册全国地图
                if (!mapRegisteredRef.current.china && china) {
                    const fixedChina = JSON.parse(JSON.stringify(china));
                    fixedChina.features.forEach((feat) => {
                        if (!feat.geometry)
                            return;
                        if (!feat.geometry.encodeOffsets) {
                            feat.geometry.encodeOffsets =
                                feat.geometry.type === "MultiPolygon"
                                    ? feat.geometry.coordinates.map(() => [0, 0])
                                    : [[0, 0]];
                        }
                    });
                    echarts.registerMap("china", fixedChina);
                    mapRegisteredRef.current.china = true;
                }
                // 注册上海地图
                if (!mapRegisteredRef.current.shanghai && sh) {
                    const fixedSh = JSON.parse(JSON.stringify(sh));
                    fixedSh.features.forEach((feat) => {
                        if (!feat.geometry)
                            return;
                        if (!feat.geometry.encodeOffsets) {
                            feat.geometry.encodeOffsets =
                                feat.geometry.type === "MultiPolygon"
                                    ? feat.geometry.coordinates.map(() => [0, 0])
                                    : [[0, 0]];
                        }
                    });
                    echarts.registerMap("shanghai", fixedSh);
                    mapRegisteredRef.current.shanghai = true;
                }
                // 注册内蒙古地图
                if (!mapRegisteredRef.current.neimenggu && neimenggu) {
                    const fixedNeimenggu = JSON.parse(JSON.stringify(neimenggu));
                    fixedNeimenggu.features.forEach((feat) => {
                        if (!feat.geometry)
                            return;
                        if (!feat.geometry.encodeOffsets) {
                            feat.geometry.encodeOffsets =
                                feat.geometry.type === "MultiPolygon"
                                    ? feat.geometry.coordinates.map(() => [0, 0])
                                    : [[0, 0]];
                        }
                    });
                    echarts.registerMap("neimenggu", fixedNeimenggu);
                    mapRegisteredRef.current.neimenggu = true;
                }
                setMapReady(true);
                setMapError(null);
            }
            catch (err) {
                const errorMsg = err instanceof Error ? err.message : "地图初始化未知错误";
                setMapError(errorMsg);
                console.error("地图加载失败:", errorMsg);
            }
        };
        const timer = setTimeout(registerAllMap, 300);
        return () => clearTimeout(timer);
    }, []);
    // 窗口resize自适应：扣除右侧3rem内边距，保证canvas宽度正常适配
    useEffect(() => {
        if (mapReady && containerRef.current) {
            const handleResize = () => {
                const chart = chartRef.current?.getEchartsInstance();
                if (chart && containerRef.current) {
                    const { width, height } = containerRef.current.getBoundingClientRect();
                    // 减去右侧paddingRight:3rem(3rem≈48px)，修正canvas宽度不适应问题
                    const chartWidth = width - 0;
                    chart.resize({ width: chartWidth, height });
                }
            };
            handleResize();
            window.addEventListener("resize", handleResize);
            return () => window.removeEventListener("resize", handleResize);
        }
    }, [mapReady, currentMapType]);
    // 自动轮播高亮区域
    useEffect(() => {
        if (mapReady && targetRegions.length > 0) {
            pollTimerRef.current = setInterval(() => {
                regionIndexRef.current =
                    (regionIndexRef.current + 1) % targetRegions.length;
                setActiveRegion(targetRegions[regionIndexRef.current]);
            }, 5000);
        }
        return () => {
            if (pollTimerRef.current)
                clearInterval(pollTimerRef.current);
        };
    }, [mapReady, currentMapType, targetRegions]);
    // 控制3D地图自动旋转
    const updateMapRotation = (rotate) => {
        const chart = chartRef.current?.getEchartsInstance();
        if (chart) {
            chart.setOption({
                geo3D: {
                    viewControl: { autoRotate: rotate, autoRotateSpeed: 3 },
                },
            });
        }
    };
    const activeArea = useRef("");
    // 生成echarts完整配置
    const getOption = () => {
        const styleConfig = getMapStyle(currentMapType);
        const viewControlConfig = getViewControl(currentMapType);
        return {
            geo3D: {
                map: currentMapType,
                roam: true,
                zoom: styleConfig.zoom,
                regionHeight: styleConfig.regionHeight,
                boxWidth: styleConfig.boxWidth,
                boxHeight: styleConfig.boxHeight,
                itemStyle: {
                    color: "#075580",
                    borderColor: styleConfig.borderColor,
                    borderWidth: styleConfig.borderWidth,
                    opacity: 1,
                },
                label: { show: false },
                emphasis: {
                    label: {
                        show: true,
                        color: "#fff",
                        formatter(params) {
                            activeArea.current = params.name;
                            return activeArea.current;
                        },
                    },
                    itemStyle: { color: "#067CAD", borderColor: "#ffffff" },
                },
                regions: targetRegions.map((name) => ({
                    name,
                    label: {
                        show: true,
                        color: "#ffffff",
                        fontSize: 14,
                        backgroundColor: "#071F38",
                        borderColor: "#ffffff",
                        borderRadius: 6,
                        padding: [10, 10],
                        emphasis: { show: true },
                    },
                    itemStyle: {
                        color: activeRegion === name ? "#00ccff" : "#40a9ff",
                    },
                    emphasis: {
                        label: {
                            show: true,
                            color: "#ffffff",
                            fontSize: 14,
                            backgroundColor: "#071F38",
                            borderColor: "#ffffff",
                            borderRadius: 6,
                            padding: [10, 10],
                        },
                        itemStyle: {
                            color: activeRegion === name ? "#00ccff" : "#40a9ff",
                        },
                    },
                })),
                viewControl: viewControlConfig,
                light: { main: { intensity: 1.5 } },
            },
        };
    };
    // 图表初始化事件绑定
    const handleChartInit = (echartsInstance) => {
        const zr = echartsInstance.getZr();
        zr.off("click");
        echartsInstance.off("mouseover");
        echartsInstance.off("mouseout");
        echartsInstance.on("mouseover", () => {
            setIsRotating(false);
            updateMapRotation(false);
        });
        echartsInstance.on("mouseout", () => {
            setIsRotating(true);
            updateMapRotation(true);
        });
        zr.on("click", () => {
            const hoverName = activeArea.current;
            const matchItem = dataSourceRef.current.find((item) => item.cname === hoverName);
            // 全国地图点击可下钻省份，切换对应子地图
            if (currentMapType === "china") {
                const childMap = drillMapConfig[hoverName];
                if (childMap) {
                    setCurrentMapType(childMap);
                    const childList = getRegionListByMap(dataSourceRef.current, childMap);
                    setActiveRegion(childList[0] || childList[0]);
                    regionIndexRef.current = 0;
                    return;
                }
            }
            else {
                // 子地图（上海/内蒙古）点击空白区域返回全国地图
                const childAreaList = getRegionListByMap(dataSourceRef.current, currentMapType);
                if (!childAreaList.includes(hoverName)) {
                    setCurrentMapType("china");
                    const chinaList = getRegionListByMap(dataSourceRef.current, "china");
                    setActiveRegion(chinaList[0] || "上海市");
                    regionIndexRef.current = 0;
                    return;
                }
            }
            if (matchItem) {
                setIsClicking(true);
                setTimeout(() => setIsClicking(false), 200);
                setActiveRegion(hoverName);
                regionIndexRef.current = dataSourceRef.current.indexOf(matchItem);
            }
            onClick?.(hoverName);
        });
    };
    return (_jsxs("div", { ref: containerRef, className: `relative bg-transition ${className}`, style: {
            width: "100%",
            height: "100%",
            position: "relative",
            overflow: "hidden",
            boxSizing: "border-box",
        }, children: [currentMapType !== "china" && (_jsx("button", { onClick: () => {
                    setCurrentMapType("china");
                    const chinaList = getRegionListByMap(dataSource, "china");
                    setActiveRegion(chinaList[0] || "上海市");
                    regionIndexRef.current = 0;
                }, style: {
                    position: "absolute",
                    top: 10,
                    left: 10,
                    zIndex: 99,
                    padding: "0.1rem",
                    background: "#fff",
                    border: "none",
                    borderRadius: 4,
                    color: "#000",
                    cursor: "pointer",
                    fontSize: "0.14rem",
                }, children: "\u8FD4\u56DE\u5168\u56FD\u5730\u56FE" })), _jsxs("div", { style: { position: "absolute", inset: 0 }, children: [mapError && (_jsxs("div", { style: {
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            flexDirection: "column",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#ff4d4f",
                            padding: "0.20rem",
                        }, children: [_jsx("span", { style: { fontSize: "0.22rem" }, children: "\u5730\u56FE\u52A0\u8F7D\u5931\u8D25" }), _jsx("p", { children: mapError })] })), !mapError && mapReady ? (_jsx(EChartsReact, { ref: chartRef, onChartReady: handleChartInit, option: getOption(), notMerge: true, style: {
                            width: "100%",
                            height: "100%",
                            transform: currentMapType === "china"
                                ? "translateY(1rem) translateX(-1rem)"
                                : "translate(0,0)",
                        } })) : !mapError ? (_jsx("div", { style: {
                            width: "100%",
                            height: "100%",
                            display: "flex",
                            alignItems: "center",
                            justifyContent: "center",
                            color: "#fff",
                            fontSize: "0.22rem",
                        }, children: "\u5730\u56FE\u52A0\u8F7D\u4E2D..." })) : null] }), activeRegion && regionDetails[activeRegion] && (_jsxs("div", { className: "bg-gradient-to-b from-[rgba(7,47,95,0.99)] to-[rgba(7,47,95,0.99)]", style: {
                    position: "absolute",
                    top: "2%",
                    right: "1%",
                    width: "2.2rem",
                    maxHeight: "90%",
                    overflowY: "auto",
                    padding: "0.05rem",
                    border: "0.01rem solid rgba(0, 204, 255, 0.5)",
                    borderRadius: "0.08rem",
                    zIndex: 2,
                    animation: "slideIn 0.3s ease-out",
                    opacity: 0.92,
                }, children: [_jsx("style", { children: `
      @keyframes slideIn {
        from { opacity: 0; transform: translate(0.30rem, -50%); }
        to { opacity: 1; transform: translate(0, -50%); }
      }
      .ant-descriptions-bordered {
        --antd-descriptions-border-color: rgba(0, 204, 255, 0.5) !important;
      }
      .ant-descriptions-bordered .ant-descriptions-item {
        border-bottom: 0.01rem solid var(--antd-descriptions-border-color) !important;
        padding: 0 0 !important;
      }
      .ant-descriptions-bordered .ant-descriptions-item:last-child {
        border-bottom: none !important;
      }
      .ant-descriptions-item-label {
        font-size: 0.16rem !important;
        color: #8ec5fc !important;
        font-weight: 600 !important;
      }
      .ant-descriptions-item-content {
        font-size: 0.16rem !important;
        color: #e0f7ff !important;
      }
    ` }), _jsxs("span", { style: {
                            margin: "0 0 0.15rem 0",
                            color: "#00ccff",
                            borderBottom: "0.01rem solid rgba(0, 204, 255, 0.5)",
                            display: "flex",
                            alignItems: "center",
                            fontSize: "0.17rem",
                        }, children: [_jsx("img", { style: { marginRight: "0.08rem", width: "0.22rem" }, src: Icon }), regionDetails[activeRegion].cname] }), _jsxs(Descriptions, { column: 1, children: [_jsxs(Descriptions.Item, { label: "\u8D44\u4EA7\u603B\u6570", children: [regionDetails[activeRegion].count, " \u9879"] }), _jsxs(Descriptions.Item, { label: "\u8D44\u4EA7\u539F\u503C", children: ["\u00A5 ", (regionDetails[activeRegion].value / 10000).toFixed(2), " \u4E07\u5143"] }), _jsxs(Descriptions.Item, { label: "\u8D44\u4EA7\u51C0\u503C", children: ["\u00A5 ", (regionDetails[activeRegion].netValue / 10000).toFixed(2), " \u4E07\u5143"] }), _jsxs(Descriptions.Item, { label: "\u672C\u6708\u589E\u52A0", children: [regionDetails[activeRegion].inboundAssetNum, " \u9879"] }), _jsxs(Descriptions.Item, { label: "\u672C\u6708\u51CF\u5C11", children: [regionDetails[activeRegion].outboundAssetNum, " \u9879"] }), _jsxs(Descriptions.Item, { label: "\u672C\u6708\u62A5\u5E9F", children: [regionDetails[activeRegion].scrapAssetNum, " \u9879"] })] })] }))] }));
};
export default AssetMapAndtL7;
